import styled from 'styled-components';

const Container = styled.div`
  padding: 0 20px;
  font-family: "Helvetica Neue", Arial, sans-serif;
  min-width: 230px;
  max-width: 230px;
`;

export default Container;
